function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { BaseResources } from "./BaseResources";
export var Resources = /*#__PURE__*/function (_BaseResources) {
  _inherits(Resources, _BaseResources);
  var _super = _createSuper(Resources);
  function Resources() {
    var _this;
    var loaders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, Resources);
    _this = _super.call(this);
    _this.loaders = loaders;
    return _this;
  }
  _createClass(Resources, [{
    key: "loader",
    value: function loader(_loader) {
      this.loaders.push(_loader);
      return this;
    }
    // ready() {
    //     for (let asset of this.bundles.assets) {
    //         this.loadAssetResource(asset.id);
    //     }
    //     return this.load();
    // }
    // private loadAssetResource<T>(id: string): Resource<T> {
    //     if (!this.bundles.exists(id)) {
    //         throw new Error(`unable use load asset id: ${id}`);
    //     }
    //     const resource = new Resource<T>(`asset:${id}`,() => {
    //         return this.bundles.load(id)
    //     });
    //     this.addResource(resource);
    //     return resource;
    // }
  }, {
    key: "loadResource",
    value: function loadResource(uri) {
      var loader = this.loaders.find(function (loader) {
        return loader.test(uri);
      });
      if (!loader) {
        throw new Error("unable load resource, uri: ".concat(uri));
      }
      var resource = loader.load(uri);
      // const resource = new Resource<T>(() => {
      //     return loader.load(uri);
      // }, {
      //     name: `uri:${uri}`
      // });
      this.addResource(uri, resource);
      return resource;
    }
  }, {
    key: "use",
    value: function use(uri) {
      var resource = this.getResource(uri.toString());
      if (resource) {
        return resource;
      }
      return this.loadResource(uri);
    }
  }]);
  return Resources;
}(BaseResources);